import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css = ".TOTPEnrollQRScreen_module_qr__ae8d607c{display:block;margin:0 auto}";
collectCss(css);
var modules_b00e876f = {"qr":"TOTPEnrollQRScreen_module_qr__ae8d607c"};

export { css, modules_b00e876f as default };
//# sourceMappingURL=TOTPEnrollQRScreen.module.css.mjs.map
